import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import coverSrc from 'assets/img/generic/4.jpg';
import Flex from 'components/common/Flex';
import VerifiedBadge from 'components/common/VerifiedBadge';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react'
import { Button, Col, Row, Card } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import useToken from '../../hooks/useToken';

const Banner = ({ perfil, setShowModalFoto, imagenPerfil }) => {
    const { idUsuario, token } = useToken();
    const { id } = useParams();
    const [setCalculoVacaciones] = useState({
        diasTotales: 0,
        diasUtilizados: 0,
        diasDisponibles: 0,
        aniosServicio: 0,
        desglosePorAnio: []
    });

    const loadCalculoVacaciones = async () => {
        try {
            const response = await fetch(`/api/vacaciones/CalcularDiasVacacionesLFT?idUsuario=${perfil.idUsuario}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            const data = await response.json();
            if (data.iResponseType === 1 && data.detalles) {
                const detalles = JSON.parse(data.detalles);
                const resumen = detalles.table2?.[0] || detalles.Table2?.[0];
                const desglose = detalles.table3 || detalles.Table3 || [];

                if (resumen) {
                    setCalculoVacaciones({
                        diasTotales: resumen.iDiasTotalesAcumulados || 0,
                        diasUtilizados: resumen.iDiasUtilizados || 0,
                        diasDisponibles: resumen.iDiasDisponibles || 0,
                        aniosServicio: resumen.iAniosServicio || 0,
                        proximoAniversario: resumen.dProximoAniversario || null,
                        diasHastaProximoAniversario: resumen.iDiasHastaProximoAniversario || 0,
                        estadoAniosServicio: resumen.vEstadoAniosServicio || '',
                        desglosePorAnio: Array.isArray(desglose) ? desglose.map(d => ({
                            iAnio: d.iAnio || 0,
                            vDescripcionAnio: d.vDescripcionAnio || `Año ${d.iAnio}`,
                            dFechaInicio: d.dFechaInicio || '',
                            dFechaFin: d.dFechaFin || '',
                            iDiasGenerados: d.iDiasGenerados || 0,
                            iDiasUtilizados: d.iDiasUtilizados || 0,
                            iDiasDisponibles: d.iDiasDisponibles || 0,
                            bPeriodoActivo: d.bPeriodoActivo || false,
                            bPeriodoCompletado: d.bPeriodoCompletado || false,
                            decPorcentajeAvance: d.decPorcentajeAvance || 0,
                            vEstadoPeriodo: d.vEstadoPeriodo || 'Desconocido'
                        })) : []
                    });
                }
            }

        } catch (error) {
            console.error('Error al cargar cálculo de vacaciones:', error);
        }
    };


    useEffect(() => {
        if (perfil && perfil.idUsuario) {
            loadCalculoVacaciones();
        }
    }, [perfil]);

    return (
        <div className="mb-4">
            <div className="d-flex align-items-center gap-4 mb-4">
                <div className="position-relative">
                    <img
                        src={imagenPerfil || coverSrc}
                        alt="Perfil"
                        className="rounded-3 object-fit-cover"
                        style={{ width: '120px', height: '120px' }}
                    />
                    {(idUsuario == perfil?.idUsuario || !id) && (
                        <Button
                            size="sm"
                            variant="light"
                            className="position-absolute bottom-0 end-0 m-1 shadow-sm border"
                            onClick={() => setShowModalFoto(true)}
                        >
                            <FontAwesomeIcon icon="edit" />
                        </Button>
                    )}
                </div>
                <div>
                    <h3 className="fw-bold text-dark text-uppercase mb-1 d-flex align-items-center gap-2">
                        {perfil.vNombre} {perfil.vApellidos} <VerifiedBadge />
                    </h3>
                    <h5 className="fw-bold text-primary text-uppercase mb-1 d-flex align-items-center gap-2">
                        @{perfil.vUsuario}
                    </h5>
                    <h5 className="fw-bold text-primary text-uppercase mb-1 d-flex align-items-center gap-2">
                        {perfil.vNombreTipoUsuario}
                    </h5>
                </div>
            </div>

            <Row className="g-3">
                <Col xs={12} lg={12}>
                    <Card className="h-100 border-0 shadow-sm p-4">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h5 className="fw-bold mb-0 text-secondary">Información de Usuario</h5>
                            <FontAwesomeIcon icon="info-circle" className="text-muted" />
                        </div>
                        <Row className="g-4">
                            <Col xs={12} md={4}>
                                <span className="text-uppercase text-muted d-block small fw-bold mb-1">Correo Electrónico</span>
                                <div className="d-flex align-items-center gap-2 text-dark">
                                    <Flex alignItems="center" className="mb-2">
                                        <img
                                            src="/img/email48.png"
                                            width={30}
                                            className="me-2"
                                            alt="email"
                                        />
                                            <span className="mb-0">{perfil.vEmailTrabajo}</span>
                                    </Flex>
                                </div>
                            </Col>
                            <Col xs={12} md={4}>
                                <span className="text-uppercase text-muted d-block small fw-bold mb-1">FECHA DE NACIMIENTO</span>
                                <div className="d-flex align-items-center gap-2 text-dark">
                                    <Flex alignItems="center" className="mb-2">
                                        <img
                                            src="/img/cumple48.png"
                                            width={30}
                                            className="me-2"
                                            alt="cumpleaños"
                                        />
                                            <span>{perfil.dFechaNacimiento}</span>
                                    </Flex>
                                </div>
                            </Col>
                            <Col xs={12} md={4}>
                                <span className="text-uppercase text-muted d-block small fw-bold mb-1">TELEFONO PERSONAL</span>
                                <div className="d-flex align-items-center gap-2 text-dark">
                                    <img src="/img/whatsapp40.png" width={30} className="me-2" alt="whatsapp" />
                                    <span>{perfil.vDatosContactoPersonal || 'Sin WhatsApp'}</span>
                                </div>
                            </Col>
                            <Col xs={12} md={4}>
                                <span className="text-uppercase text-muted d-block small fw-bold mb-1">DOMICILIO</span>
                                <div className="d-flex align-items-center gap-2 text-dark pt-1">
                                    <FontAwesomeIcon icon="map-marker-alt" className="text-muted me-2" size="lg" />
                                    <span>{perfil.vDomicilioPersonal || 'No especificado'}</span>
                                </div>
                            </Col>
                            <Col xs={12} md={4}>
                                <span className="text-uppercase text-muted d-block small fw-bold mb-1">CURP DEL EMPLEADO</span>
                                <div className="d-flex align-items-center gap-2 text-dark pt-1">
                                    <FontAwesomeIcon icon="building" className="text-muted me-2" size="lg" />
                                    <Flex alignItems="center" className="mb-2">
                                        <FontAwesomeIcon
                                            icon="user-circle"
                                            className="me-2 text-700"
                                            style={{ height: '30px', width: '30px' }}
                                        />
                                            <span className="mb-0">{perfil.vCURP}</span>
                                    </Flex>
                                </div>
                            </Col>                            
                            <Col xs={12} md={4}>
                                <span className="text-uppercase text-muted d-block small fw-bold mb-1">TELEFONO DEL EMPLEADO</span>
                                <div className="d-flex align-items-center gap-2 text-dark">
                                    <Flex alignItems="center" className="mb-2">
                                        <img
                                            src="/img/telefono48.png"
                                            width={30}
                                            className="me-2"
                                            alt="teléfono"
                                        />
                                            <span>{perfil.vTelefonoTrabajo || 'No asignado'}</span>
                                    </Flex>
                                </div>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

Banner.propTypes = {
    perfil: PropTypes.object,
    setShowModalFoto: PropTypes.func,
    imagenPerfil: PropTypes.string,
    onVacationUpdate: PropTypes.func
};



export default Banner;